import { useLayoutEffect } from "react";

import ActionComponent from "../components/ActionComponent/ActionComponent.js";
import UpsellModal from "../components/modals/UpsellModal/UpsellModal.js";
import { useAppSelector } from "../hooks/redux.js";

const EDIT_SAVE_BAR_ID = "edit-save-bar";

const Edit = () => {
  // No save bar on "Choose your action": nothing has been changed yet, and while a save bar is
  // showing the admin blocks in-app navigation, which left it stuck on the dashboard after Back.
  const isContextBarVisible = useAppSelector((state) => state.action.currentStep > 0);

  // Layout effect so the cleanup runs while <ui-save-bar> is still in the DOM.
  useLayoutEffect(() => {
    if (!isContextBarVisible) return;

    shopify.saveBar.show(EDIT_SAVE_BAR_ID);
    return () => {
      shopify.saveBar.hide(EDIT_SAVE_BAR_ID);
    };
  }, [isContextBarVisible]);

  return (
    <>
      <ui-save-bar id={EDIT_SAVE_BAR_ID} discardConfirmation>
        <button variant="primary" disabled></button>
        <button disabled></button>
      </ui-save-bar>
      <ActionComponent />
      <UpsellModal />
    </>
  );
};

export default Edit;
